/**
 * @desc getStockOccupyDetailByOperationNo
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.StockOccupyDetailResponseDto>>;
export function request(
  params: API.tms.stockOccupyFacadeImpl.getStockOccupyDetailByOperationNo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/getStockOccupyDetailByOperationNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
